import React, { useEffect } from 'react';
import './tailwind.css'; // Assuming your DaisyUI/Tailwind setup is here
import { Route, Routes } from 'react-router-dom'; // Removed Navigate as it wasn't used directly here

// Components
import Header from './components/Header';
import ProtectedRoute from './components/ProtectedRoute';
import ConsentModal from './components/ConsentModal'; // Path to your ConsentModal component

// Pages
import PlayerPage from './pages/PlayerPage';
import MainMenuPage from './pages/MainMenuPage';
import AboutUsPage from './pages/AboutUsPage';
import AuthPage from './pages/AuthPage';
import AddTeamPage from './pages/AddTeamPage';
import UserPage from './pages/UserPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import UpdatePasswordPage from './pages/UpdatePasswordPage.'; // Corrected the dot at the end
// import MyPageComponent from './pages/Ballsack'; // Example page component


const App = () => {
  useEffect(() => {
    // Set the DaisyUI theme for the entire application
    // Your existing code already sets it to 'dark'. This is good.
    // If you specifically wanted the "night" theme aesthetics, you could change 'dark' to 'night'.
    document.documentElement.setAttribute('data-theme', 'dark');
  }, []);

  // Define your consent purposes based on your Cloudflare Zaraz setup
  // The 'id' values MUST match the "ID" (Purpose Key) from your Zaraz dashboard screenshot.
  const myConsentPurposes = [
    {
      id: 'Dsrq', // From your screenshot: Essential & Security
      name: 'Essential & Security',
      description: 'These are required for the website to function securely and properly. They cannot be switched off.',
      isEssential: true,
    },
    {
      id: 'eYNL', // From your screenshot: Performance & Analytics (Cloudflare Monitoring)
      name: 'Performance & Analytics',
      description: 'These allow us to count visits and traffic sources, helping us measure and improve the performance of our site (e.g., using Cloudflare Web Analytics).',
      isEssential: false,
      defaultGranted: true, // Example: You might want analytics on by default but allow opt-out
    },
    {
      id: 'JKxI', // From your screenshot: Error Monitoring (MS Clarity)
      name: 'Error Monitoring & User Experience',
      description: 'Helps us identify and fix errors, and understand user behavior to improve website usability (e.g., using Microsoft Clarity).',
      isEssential: false,
      defaultGranted: false, // Example: MS Clarity might be more privacy-impacting, so off by default
    }
    // Add any other purposes you might have or plan to add in Zaraz
  ];

  return (
    // Your App.js assumes that <BrowserRouter> wraps this <App /> component in your index.js or a higher-level file.
    <div className="flex flex-col min-h-screen bg-base-200">
      <Header />

      <main className="flex-grow mx-auto w-full px-4">
        <Routes>
          {/* Public Routes */}
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/update-password" element={<UpdatePasswordPage />} />
          {/* Protected Routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/main-menu" element={<MainMenuPage />} />
            <Route path="/" element={<MainMenuPage />} /> {/* Default route after login */}
            <Route path="/user" element={<UserPage />} />
            <Route path="/addteam" element={<AddTeamPage />} />
            <Route path="/player/:playerid" element={<PlayerPage />} />
            {/* Add other routes that require login here */}
          </Route>

          {/* Optional: Catch-all 404 Not Found Route - Place it last */}
          {/* <Route path="*" element={<NotFoundPage />} /> */}
        </Routes>
      </main>

      {/* Optional Footer can go here */}
      {/* <footer className="p-4 bg-base-300 text-base-content text-center">
        <p>&copy; {new Date().getFullYear()} Your Company Name. All rights reserved.</p>
      </footer> */}

      {/* Render the Consent Modal */}
      <ConsentModal
        purposes={myConsentPurposes}
        privacyPolicyUrl="/privacy" // Link to your PrivacyPage
        cookiePolicyUrl="/terms"   // Or a dedicated cookie policy page if you have one
        // zarazConsentCookieName="cf_consent" // Default is "cf_consent", adjust if needed
      />
    </div>
  );
}

export default App;